import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAddSubCategory from "../../Components/Admin/AdminAddSubCategory";
import AdminSideBar from "../../Components/Admin/AdminSideBar";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddSubCategoryPage = () => {
  return (
    <div className="d-flex justify-content-start">
      <div>
        <SideBar />
      </div>
      <div className="p-4" style={{ width: '100%' }}>
        <AdminAddSubCategory />
      </div>
    </div>
  );
};

export default AdminAddSubCategoryPage;
